/**
 * Профилът на влезлия потребител — TASK_44. Изнесено от `useAuth.tsx`, за да остане онзи файл
 * само с компоненти (react-refresh) и функцията да се тества сама.
 */
import type { User as AppUser, CustomClaims } from '@shared/types';

/** Полетата на САМОЛИЧНОСТТА — идват само от Auth/claims, никога от документа в `users`. */
const САМОЛИЧНОСТ = ['userId', 'email', 'role', 'schoolId', 'familyId'] as const;

/**
 * Профилът = ПРЕДПОЧИТАНИЯТА от документа в `users` + САМОЛИЧНОСТТА от Auth и custom claims
 * (TASK_44, решение на гейта 05.10.2026).
 *
 * 🔴 Документът НЕ заменя claims. До 05.10 имаше ли документ, профилът беше САМО той — а
 * смяната на езика (`setPreferredLanguage`) създава документ само с `{ preferredLanguage }`.
 * Родителят оставаше без `familyId` и таблото показваше „0 декларации" (production: 5 от 335).
 *
 * 🔴 `role`/`familyId`/`schoolId` — САМО от claims, дори когато claims мълчат. Claims пише само
 * Admin SDK и по тях авторизират правилата и функциите; документът `users/{uid}` потребителят
 * може да СЪЗДАДЕ сам с произволни полета (правилото за `create` не ги ограничава). Измерено на
 * production 05.10: 0 разминавания между двете — правилото не сменя нищо за никого освен
 * петимата засегнати. Email и uid — от Auth.
 */
export function buildUserProfile(input: {
  uid: string;
  authEmail: string | null | undefined;
  claims: CustomClaims;
  doc: Record<string, unknown> | null;
  displayName: string | undefined;
}): AppUser {
  const preferences: Record<string, unknown> = { ...(input.doc ?? {}) };
  for (const key of САМОЛИЧНОСТ) delete preferences[key];
  return {
    ...preferences,
    userId: input.uid,
    displayName: input.displayName,
    email: input.authEmail || undefined,
    role: input.claims.role,
    schoolId: input.claims.schoolId,
    familyId: input.claims.familyId,
  } as AppUser;
}
